export const EXCEPTION_TYPES = {
  Color: 'Color',
  Contamination: 'Contamination',
  Damage: 'Damage',
  Delay: 'Delay',
  Extra: 'Extra',
  'Extra Item': 'Extra Item',
  'No Access': 'No Access',
  'No Payment': 'No Payment',
  'Not Out': 'Not Out',
  Overloaded: 'Overloaded',
  Photo: 'Photo',
  Safety: 'Safety',
  'Service Review': 'Service Review',
  Size: 'Size',
  Special: 'Special',
  Weight: 'Weight',
  Sign: 'Sign',
}

// Replace other sources with this
export const EXCEPTION_TYPES_NEW = {
  Contamination: 'Contamination',
  Damage: 'Damage',
  Delay: 'Delay',
  'Extra Item': 'Extra Item',
  Location: 'Location',
  'No Access': 'No Access',
  Note: 'Note',
  Overloaded: 'Overloaded',
  Photo: 'Photo',
  Safety: 'Safety',
  'Serial Number': 'Serial Number',
  'Service Review': 'Service Review',
  Sign: 'Sign',
  Special: 'Special',
  Weight: 'Weight',
}
